import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Margin from "Components/Stats/Margin";
import NivoPie from "Components/Stats/Charts/NivoPie";
import { getCompanyOffersByCategoryData } from "Components/Stats/Data/Entreprises/Entreprises";
import { getCompanyOffersByCategoryByMonthData } from "Components/Stats/Data/Entreprises/Entreprises";
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import NivoBar from "Components/Stats/Charts/NivoBar";
import { Offers } from "Components/Stats/Data/Const";

const CompanyOffersByCategory = (props) => {
  const [companyOffersByCategory, setCompanyOffersByCategory] = useState([]);
  const [companyOffersByCategoryByMonth, setCompanyOffersByCategoryByMonth] =
    useState([]);
  const [selectedCompany, setSelectedCompany] = useState("Entreprise 1");
  const op = useRef();

  const handleClick = (e) => {
    if (e.target) setSelectedCompany(e.target.outerText);
    op.current.hide();
  };
  useEffect(() => {
    setCompanyOffersByCategory(getCompanyOffersByCategoryData());
    setCompanyOffersByCategoryByMonth(getCompanyOffersByCategoryByMonthData());
  }, [selectedCompany]);

  return (
    <React.Fragment>
      <Button
        type="button"
        label={selectedCompany}
        onClick={(e) => op.current.toggle(e)}
        //? Centrer le bouton
        style={{ display: "block", margin: "auto" }}
      />
      <OverlayPanel ref={op} className="stats-panel">
        <Button id="1" label="Entreprise 1" onClick={handleClick} />
        <Button id="2" label="Entreprise 2" onClick={handleClick} />
        <Button id="3" label="Entreprise 3" onClick={handleClick} />
        <Button id="4" label="Entreprise 4" onClick={handleClick} />
        <Button id="5" label="Entreprise 5" onClick={handleClick} />
      </OverlayPanel>
      <Margin position="bottom" size="xs" />
      <NivoPie
        data={companyOffersByCategory}
        title={
          "Nombre d'offres par catégorie pour l'entreprise " +
          selectedCompany +
          " sur l'université " +
          props.universityName
        }
        displayPercentage
        colors="pastel1"
      />
      <Margin position="bottom" size="s" />
      <NivoBar
        data={companyOffersByCategoryByMonth}
        title={
          "Nombre d'offres par catégorie par mois pour l'entreprise " +
          selectedCompany +
          " sur l'université " +
          props.universityName
        }
        displayPercentage
        colors="pastel1"
        displayFill={false}
        keysNames={Offers.categories}
        indexName="Date"
      />
      <Margin position="bottom" size="s" />
    </React.Fragment>
  );
};

CompanyOffersByCategory.propTypes = {
  universityName: PropTypes.string,
};

export default CompanyOffersByCategory;
